import React from 'react';

import Banner from '../../components/Banner';
import ArticleSpreader from '../../components/ArticleSpreader';
import Paragraph from '../../components/Paragraph';
import ParagraphWithImage from '../../components/ParagraphWithImage';
import Accentuation from '../../components/Accentuation';
import Fact from '../../components/Fact';
import Quote from '../../components/Quote';
import RightBanner from '../../components/RightBanner';
import Slider from '../../components/Slider';
import Roles from '../../components/Roles';
import LeftBanner from '../../components/LeftBanner';
import Article from '../../components/Article';
import EndSpreader from '../../components/EndSpreader';
import MoreArticles from '../../components/MoreArticles';
import BarChart from '../../components/BarChart';

import { Helmet } from 'react-helmet';

const InvestPage = props => (
  <div>
    <Helmet>
      <title>Забота о благосостоянии - Специальный проект Alfa Private</title>
    </Helmet>
    <Article
      banner={
        <Banner
          title="Забота о благосостоянии"
          backgroundImage="images/banners/bg.jpg"
        />
      }
      location={props.location}
      showSocialSharing
    >
      {[
        {
          body: (
            <div>
              <ArticleSpreader>
                <Paragraph>
                  <img src="images/media/zahod31-1.jpg" width="100%" />
                </Paragraph>
                <Paragraph>
                  Цифровизация сервисов и&nbsp;услуг упрощает и&nbsp;ускоряет
                  выполнение потребностей высокосостоятельных клиентов. Однако
                  сложно представить услуги Private Banking без личного общения
                  с&nbsp;менеджерами банка в&nbsp;комфортной и&nbsp;спокойной
                  атмосфере. В&nbsp;одном месте клиенту предложат комплексное
                  обслуживание, включающее разнообразные банковские
                  и&nbsp;инвестиционные продукты. Финансовый советник
                  в&nbsp;зависимости от&nbsp;потребности клиента подберет
                  индивидуальное решение, а&nbsp;также проконтролирует, чтобы
                  риски оставались на&nbsp;приемлемом уровне.
                </Paragraph>
                <Paragraph>
                  На&nbsp;сегодняшний день{' '}
                  <a
                    href="https://alfabank.ru/alfaprivate/?platformId=kommersant_special_project_alfaprivate_article3&utm_source=kommersant&utm_medium=special_project&utm_campaign=alfaprivate&utm_term=null&utm_content=article3"
                    target="_blank"
                  >
                    Альфа Private
                  </a>{' '}
                  насчитывает{' '}
                  <Accentuation>
                    14 отделений в&nbsp;крупнейших городах России. В&nbsp;начале
                    октября было открыто флагманское представительство
                    в&nbsp;историческом центре Москвы&nbsp;&mdash;
                    в&nbsp;Денежном переулке.{' '}
                  </Accentuation>
                  Офис расположился в&nbsp;старинном особняке, но&nbsp;оформлен
                  в&nbsp;современном стиле и&nbsp;оснащен новейшими
                  технологическими решениями. Белоснежный лаконичный интерьер,
                  элементы исторической кирпичной кладки, приглушенная музыка
                  и&nbsp;высококвалифицированный персонал на&nbsp;ресепшн
                  погружают клиента в&nbsp;атмосферу комфорта
                  и&nbsp;благополучия.
                </Paragraph>
                <Fact source="По данным Frank Research Group">
                  По состоянию на середину 2018 года
                  <br />
                  <span
                    style={{
                      fontSize: '40px',
                      paddingTop: '12px',
                      display: 'inline-block',
                    }}
                  >
                    75-80%
                  </span>
                  сбережений высокосостоятельных клиентов приходится на вклады
                </Fact>
                <Paragraph>
                  В&nbsp;новом отделении клиенты могут не&nbsp;только
                  насладиться созданной атмосферой,
                  но&nbsp;и&nbsp;протестировать новейшую разработку&nbsp;&mdash;
                  VR-переговорную. С&nbsp;помощью технологии будущего они
                  погружаются в&nbsp;виртуальное пространство, где получают
                  консультацию по&nbsp;инвестициям с&nbsp;помощью прообраза
                  &laquo;виртуального помощника&raquo;.{' '}
                  <Accentuation>
                    Если хочется живого общения, то&nbsp;финансовый советник,
                    представляющий собой единую точку входа ко&nbsp;всем
                    возможностям Альфа-Групп и&nbsp;его партнеров, окажет помощь
                    в&nbsp;решении как классических задач, так и&nbsp;выходящих
                    за&nbsp;их&nbsp;рамки.{' '}
                  </Accentuation>
                  &laquo;У&nbsp;нас есть эффективные сервисы и&nbsp;продуктовые
                  предложения на&nbsp;стыке частных и&nbsp;корпоративных
                  интересов, которые удовлетворят любой запрос
                  клиента&raquo;,&nbsp;&mdash; рассказывает управляющий директор
                  Альфа Private Катерина Милеева.
                </Paragraph>
              </ArticleSpreader>

              <Paragraph>
                <RightBanner image="images/media/invest11.jpg">
                  Клиенты все больше хотят быть вовлеченными в процесс
                  управления инвестиционным портфелем
                </RightBanner>
              </Paragraph>
            </div>
          ),
        },
        {
          title: 'Классический банкинг',
          banner: (
            <Banner
              title="Private Banking: обзор"
              backgroundImage="images/banners/bg.jpg"
            />
          ),
          body: (
            <div>
              <ArticleSpreader>
                <Paragraph>
                  Традиционный Private Banking включает широкий набор
                  эксклюзивных услуг по&nbsp;трем ключевым направлениям:
                  банковское, инвестиционное, консультационное. В&nbsp;последние
                  годы банки активно внедряют разнообразные дополнительные
                  сервисы&nbsp;&mdash; консьерж, бонусные программы, страхование
                  всей семьи. Клиенты на&nbsp;свое усмотрение могут обращаться
                  в&nbsp;банк как за&nbsp;отдельными услугами, так
                  и&nbsp;за&nbsp;комплексным обслуживанием.{' '}
                  <Accentuation>
                    &laquo;Нередки случаи, когда состоятельные клиенты приходят
                    к&nbsp;нам с&nbsp;отдельно взятой задачей, по&nbsp;мере
                    решения которой могут всплыть дополнительные налоговые или
                    юридические нюансы.{' '}
                  </Accentuation>
                  И&nbsp;поэтому мы&nbsp;должны быть всегда готовы решать любой
                  спектр задач начиная от&nbsp;точечных и&nbsp;заканчивая
                  комплексными&raquo;,&nbsp;&mdash; отмечает управляющий
                  директор по&nbsp;развитию продуктов Альфа Private Антон
                  Рахманов.
                </Paragraph>
              </ArticleSpreader>

              <ArticleSpreader>
                <Paragraph>
                  Уже более двух веков основой сбережений высокосостоятельных
                  клиентов являются вклады. По&nbsp;оценкам Frank Research
                  Group, на&nbsp;середину 2018 года на&nbsp;этот продукт
                  приходилось 75&ndash;80% клиентских средств.
                  &laquo;Депозиты&nbsp;&mdash; очень удобный, понятный,
                  безналоговый инструмент для сбережения
                  средств&raquo;,&nbsp;&mdash; отмечает проектный директор Frank
                  RG&nbsp;Любовь Прокопова. К&nbsp;тому&nbsp;же
                  в&nbsp;Альфа-Банке состоятельный клиент может проводить
                  конвертацию по&nbsp;льготному курсу (максимально приближенному
                  к&nbsp;рыночному), а&nbsp;расчеты осуществлять в&nbsp;восьми
                  валютах: рубль, доллар, евро, фунт стерлингов, швейцарский
                  франк, канадский доллар, японская йена, китайский юань.
                  В&nbsp;случае если клиенту или его бизнесу потребуется
                  особенная кредитная линия или страховка, персональный
                  финансовый советник спланирует индивидуальное решение;
                  tailor-made решения являются ключевым инструментом при работе
                  с&nbsp;высокосостоятельными клиентами в&nbsp;Альфа Private.
                </Paragraph>
                <Paragraph>
                  Для клиентов Private могут быть предложены особые условия
                  в&nbsp;том числе и&nbsp;по&nbsp;размещению средств
                  с&nbsp;точки зрения не&nbsp;только ценовых параметров,
                  но&nbsp;и&nbsp;дополнительных: режим начисления процентов,
                  условия пополнения и&nbsp;снятия, возможность управления
                  средствами удаленно.
                </Paragraph>
                <Paragraph>
                  <img src="images/media/invest_inner11.jpg" width="100%" />
                </Paragraph>
                <Paragraph>
                  В&nbsp;последние годы предпочтения клиентов все сильнее
                  смещаются в&nbsp;сторону инвестиционных продуктов.
                  По&nbsp;оценкам Frank Research Group, если в&nbsp;2015 году
                  на&nbsp;такие вложения приходилось только 10% всех активов
                  на&nbsp;рынке, то&nbsp;в&nbsp;2018 году этот показатель вырос
                  до&nbsp;20%. По&nbsp;словам Любови Прокоповой, некоторые
                  игроки за&nbsp;счет развитого инвестиционного предложения
                  и&nbsp;экспертизы достигают более высоких показателей
                  по&nbsp;доле инвестиций.{' '}
                  <Accentuation>
                    В&nbsp;Альфа Private в&nbsp;2017 году инвестиционный
                    портфель высокосостоятельных клиентов вырос в&nbsp;два раза.
                    Для простоты осуществления операций по&nbsp;счету инвесторам
                    доступны все онлайн-сервисы: мобильный банк Альфа-Мобайл,
                    интернет-банк Альфа-Клик, онлайн-трейдинг Альфа-Директ,
                    телефонный банкинг по&nbsp;выделенной линии{' '}
                    <a
                      href="https://alfabank.ru/alfaprivate/?platformId=kommersant_special_project_alfaprivate_article3&utm_source=kommersant&utm_medium=special_project&utm_campaign=alfaprivate&utm_term=null&utm_content=article3"
                      target="_blank"
                    >
                      Private Banking.{' '}
                    </a>
                  </Accentuation>
                </Paragraph>
                <Paragraph>
                  &laquo;Клиенты все больше хотят быть вовлеченными
                  в&nbsp;процесс управления инвестиционным портфелем: они хотят
                  понимать, что происходит с&nbsp;их&nbsp;инвестициями,
                  и&nbsp;участвовать в&nbsp;принятии решений. Поэтому
                  мы&nbsp;активно развиваемся в&nbsp;сторону advisory-модели,
                  предлагая клиентам формат взаимодействия, при котором
                  он&nbsp;может самостоятельно принимать решения, связанные
                  с&nbsp;размещением активов, опираясь на&nbsp;нашу экспертизу
                  и&nbsp;аналитическую поддержку&raquo;,&nbsp;&mdash;
                  рассказывает Катерина Милеева.
                </Paragraph>
                <Paragraph>
                  Ключевым экономическим локомотивом растущего в&nbsp;последние
                  годы спроса на&nbsp;инвестиционные продукты стало снижение
                  ставок по&nbsp;вкладам. По&nbsp;данным Банка России,
                  в&nbsp;начале 2015 года ставки по&nbsp;валютным вкладам сроком
                  больше одного года превышали 5% годовых, а&nbsp;через год уже
                  составляли 2,5% годовых. Сейчас они находятся у&nbsp;отметки
                  1,6&ndash;2% годовых. Доходности рублевых вкладов снизились
                  с&nbsp;15&ndash;20% годовых до&nbsp;6,5% годовых. Даже
                  с&nbsp;учетом небольшого повышения ставок, произошедшего
                  в&nbsp;последние месяцы, они остаются значительно ниже
                  двухзначных значений, к&nbsp;которым инвесторы уже привыкли.
                  По&nbsp;словам Катерины Милеевой, снижение ставок побуждает
                  даже самых консервативных клиентов искать варианты размещения,
                  предлагающие приемлемую доходность.
                </Paragraph>
              </ArticleSpreader>
              <ParagraphWithImage image="images/media/invest_banner.jpg">
                Private Banking в&nbsp;ответ на&nbsp;меняющиеся предпочтения
                клиентов активно развивает инвестиционную экспертизу
                и&nbsp;расширяет линейку финансовых инструментов.
                В&nbsp;зависимости от&nbsp;суммы, которой располагает инвестор,
                а&nbsp;также его риск-профиля, персональный финансовый советник
                банка разрабатывает оптимальные варианты инвестирования.
                В&nbsp;состав инвестиционного портфеля могут входить различные
                финансовые активы (акции, облигации, драгоценные металлы,
                валюты). Наряду со&nbsp;стандартными инвестиционными продуктами
                финансовый советник может предложить индивидуальные решения:
                структурные ноты, инструменты срочного рынка и&nbsp;финансового
                инжиниринга.{' '}
                <Accentuation>
                  С&nbsp;начала года Альфа-Банк разместил среди своих клиентов
                  структурные биржевые облигации с&nbsp;доходностью, привязанной
                  к&nbsp;индексу робототехники, фьючерсам на&nbsp;нефть.
                  Доходность этих продуктов напрямую зависит от&nbsp;стоимости
                  базового актива и&nbsp;при правильно выбранной стратегии может
                  обеспечить результат, превышающий показатель банковского
                  вклада.{' '}
                </Accentuation>
                В&nbsp;случае неудачного стечения обстоятельств защита капитала,
                встроенная в&nbsp;продукт, сохранит первоначальную сумму. Это
                ценится высокосостоятельными клиентами даже больше, чем быстрый
                заработок. &laquo;Работа компании не&nbsp;заканчивается
                на&nbsp;предложении продукта. В&nbsp;течение всего срока
                обслуживания мы&nbsp;мониторим риски, которым инвестиции могут
                быть подвержены: инфраструктурные, кредитные, рыночные
                и&nbsp;многие другие. И&nbsp;реагируем на&nbsp;них, чтобы
                вернуть их&nbsp;на&nbsp;приемлемый уровень&raquo;,&nbsp;&mdash;
                отмечает Антон Рахманов. Подробнее об&nbsp;услугах расскажет
                персональный финансовый советник
              </ParagraphWithImage>
              <ArticleSpreader>
                <Paragraph>
                  <Quote
                    author={{
                      photo: 'images/media/mileeva-2.jpg',
                      nick: 'Катерина Милеева',
                      job2: 'Альфа Private',
                      position:
                        'управляющий директор Альфа Private Катерина Милеева',
                    }}
                  >
                    Один из&nbsp;наших клиентов, переезжая в&nbsp;США, обратился
                    к&nbsp;нам за&nbsp;советом по&nbsp;подбору начальной школы
                    для ребенка. Зная, что в&nbsp;Нью-Йорке выбор школы
                    в&nbsp;большей степени определяется районом проживания,
                    мы&nbsp;предположили клиенту первоначально рассмотреть
                    вопрос о&nbsp;поиске подходящей недвижимости
                    и&nbsp;в&nbsp;зависимости от&nbsp;этого подобрать лучшую
                    школу. В&nbsp;течение нескольких месяцев наш консультант
                    по&nbsp;недвижимости сопровождал клиента, просматривая
                    множество объектов. Как только вопрос с&nbsp;недвижимостью
                    был решен, мы&nbsp;также подключили консультантов
                    по&nbsp;образованию и&nbsp;помогли его сыну Александру
                    поступить в&nbsp;одну из&nbsp;лучших начальных школ города.
                  </Quote>
                </Paragraph>
                <Paragraph>
                  Комплексное банковское и&nbsp;инвестиционное обслуживание
                  доступно не&nbsp;только клиенту, но&nbsp;и&nbsp;всем членам
                  его семьи, а&nbsp;также доверенным лицам. Менеджер банка
                  оформит кредитные карты даже для детей&nbsp;&mdash;
                  с&nbsp;индивидуально настроенными лимитами. Все это поможет
                  освободить для клиента и&nbsp;его семьи большое количество
                  времени, которое можно потратить на&nbsp;создание истинной
                  ценности. Какой именно – каждый решит для себя сам.
                </Paragraph>
                <Roles title="Главные направления Private Banking">
                  {[
                    {
                      title: 'Инвестиции',
                      description: 'Помочь сохранить',
                      icon: 'images/roles/invest_small1.png',
                    },
                    {
                      title: 'Консалтинг',
                      description: 'Помочь преумножить',
                      icon: 'images/roles/consult1.png',
                    },
                    {
                      title: 'Lifestyle management',
                      description: 'Помочь потратить',
                      icon: 'images/roles/lifestyle11.png',
                    },
                  ]}
                </Roles>
              </ArticleSpreader>
            </div>
          ),
        },
        {
          title: 'Консалтинг',
          body: (
            <div>
              <ArticleSpreader>
                <Paragraph>
                  Неотъемлемой частью Private Banking являются консультационные
                  услуги: консалтинг, налоговое и финансовое планирование,
                  юридическое сопровождение сделок.
                </Paragraph>

                <Fact source="По данным Credit Suisse">
                  С 1900 года средняя стоимость предметов коллекционирования
                  выросла в<br />
                  <span
                    style={{
                      fontSize: '40px',
                      paddingTop: '12px',
                      display: 'inline-block',
                    }}
                  >
                    30 раз,
                  </span>
                  что эквивалентно годовому росту цен на 2,9% (в долларах и с
                  учетом инфляции)
                </Fact>
                <Paragraph>
                  Сотрудники банка помогут оценить налоговые последствия
                  по&nbsp;произошедшим и&nbsp;грядущим сделкам, оптимизируют
                  налогооблагаемую базу, заполнят налоговые декларации
                  за&nbsp;всех членов семьи и&nbsp;помогут с&nbsp;проведением
                  выплат. При этом помощь оказывается не&nbsp;только
                  в&nbsp;юрисдикции России,
                  но&nbsp;и&nbsp;за&nbsp;ее&nbsp;пределами. Последнее особенно
                  актуально, поскольку налоговое регулирование в&nbsp;разных
                  странах достаточно сильно отличается от&nbsp;российского,
                  и&nbsp;при совершении сделок, в&nbsp;особенности крупных,
                  очень важно знать особенности и&nbsp;нюансы местного
                  законодательства. В&nbsp;противном случае растут риски его
                  нарушить, что чревато неприятными последствиями&nbsp;&mdash;
                  начиная от&nbsp;штрафов и&nbsp;заканчивая арестом
                  собственника.
                </Paragraph>
                <Paragraph>
                  <Quote
                    author={{
                      photo: 'images/media/rahmanov1.jpg',
                      nick: 'Антон Рахманов',
                      job2: 'Альфа Private',
                      position: 'Управляющий директор по развитию продуктов',
                    }}
                  >
                    Спрос на&nbsp;нефинансовый консалтинг со&nbsp;стороны
                    клиентов Private Banking стабильно увеличивается, чему
                    способствуют наблюдающаяся в&nbsp;мире деофшоризация,
                    запущенная властями налоговая амнистия капитала,
                    а&nbsp;также появившаяся потребность в&nbsp;решении вопросов
                    преемственности в&nbsp;управлении семейным благосостоянием.
                  </Quote>
                </Paragraph>
                <Paragraph>
                  Юридическая поддержка оказывается клиентам в&nbsp;рамках
                  российского, международного и&nbsp;семейного права. Альфа
                  Private поможет с&nbsp;сопровождением сделок, подготовит
                  правовые документы, а&nbsp;впоследствии проведет регистрацию
                  прав на&nbsp;любое движимое и&nbsp;недвижимое имущество.
                  Например, при покупке заграничной недвижимости банк занимается
                  не&nbsp;только консультированием вопросов местного
                  законодательства и&nbsp;поиском подходящего объекта,
                  но&nbsp;и&nbsp;проверяет его чистоту, а&nbsp;также
                  сопровождает сделку от&nbsp;начала
                  и&nbsp;до&nbsp;ее&nbsp;регистрации. Конечно, все эти действия
                  может осуществить и&nbsp;сам клиент, прибегнув к&nbsp;услугам
                  местных риелторов или юристов.{' '}
                  <Accentuation>
                    Но&nbsp;в&nbsp;этом случае от&nbsp;него потребуются хорошее
                    знание не&nbsp;только местного языка,
                    но&nbsp;и&nbsp;особенностей законодательства, чтобы избежать
                    рисков покупки кота в&nbsp;мешке.{' '}
                  </Accentuation>
                  Персональный финансовый советник банка общается
                  с&nbsp;клиентом на&nbsp;родном языке и&nbsp;не&nbsp;является
                  заинтересованной стороной сделки, а&nbsp;значит проинформирует
                  о&nbsp;нюансах покупки этой недвижимости, регистрации
                  и&nbsp;возможной продажи. Так, во&nbsp;Франции пошлина
                  на&nbsp;оформление права собственности составляет 5,81%,
                  но&nbsp;приобретение новостройки потребует уплату НДС
                  в&nbsp;размере 20%. В&nbsp;случае продажи единая ставка налога
                  составляет 40,5%, большую часть которых составляет налог
                  на&nbsp;прирост стоимости (20%).
                </Paragraph>
                <Paragraph>
                  Если клиент&nbsp;&mdash; любитель прекрасного, банк может
                  помочь с&nbsp;консультациями по&nbsp;вопросам покупки
                  предметов искусства, раритетных автомобилей или антиквариата.
                  При правильной экспертизе предметы коллекционирования могут
                  не&nbsp;только радовать, но&nbsp;и&nbsp;приносить неплохой
                  доход. Согласно исследованию Credit Suisse, с&nbsp;1900 года
                  средняя стоимость предметов коллекционирования выросла
                  в&nbsp;30 раз, что эквивалентно годовому росту цен
                  на&nbsp;2,9% (в&nbsp;долларах и&nbsp;с&nbsp;учетом инфляции).
                  При этом из&nbsp;предметов коллекционирования лучшие
                  показатели у&nbsp;вина (рост цен в&nbsp;годовом выражении
                  с&nbsp;учетом инфляции составил 3,7%), в&nbsp;то&nbsp;время
                  как у&nbsp;объектов искусства&nbsp;&mdash; всего 1,9%
                  в&nbsp;год.
                </Paragraph>
              </ArticleSpreader>
              <Paragraph>
                <LeftBanner image="images/banners/black-banner.jpg">
                  Состояние – это более широкое понятие, чем финансовые и
                  инвестиционные активы
                </LeftBanner>
              </Paragraph>
            </div>
          ),
        },
        {
          title: 'Lifestyle Management',
          body: (
            <div>
              <ArticleSpreader>
                <Paragraph>
                  Развитие Lifestyle Management (консалтинг по&nbsp;всему
                  спектру личных задач, соответствующих высоким стандартам
                  клиента) становится новой тенденцией российского Private
                  Banking, и&nbsp;Альфа-Банк активно развивает компетенцию
                  в&nbsp;данном направлении. Кстати, в&nbsp;этом у&nbsp;клиентов
                  российских private banks очень большое преимущество
                  относительно западных банков, в&nbsp;которых такой уровень
                  сервиса доступен только клиентам family offices
                  с&nbsp;активами от&nbsp;$50&nbsp;млн.
                </Paragraph>
                <Fact>
                  Lifestyle Management в западных банках доступен только
                  клиентам family offices с активами от $50 млн
                </Fact>
                <Paragraph>
                  Lifestyle Management включает организацию самых разных
                  процессов: комфортной повседневной жизни, путешествий,
                  развлечений, решение вопросов со&nbsp;здоровьем
                  и&nbsp;wellness, построение правильной образовательной
                  траектории для детей, способствующей их&nbsp;дальнейшему
                  жизненному успеху, заботу об&nbsp;организации комфортной
                  и&nbsp;интересной жизни для родителей клиента и&nbsp;многое
                  другое. &laquo;Наша философия Lifestyle
                  Management&nbsp;&mdash; это индивидуальный подход, высочайший
                  уровень качества, непрерывная информационная поддержка клиента
                  и, конечно&nbsp;же, строжайшая
                  конфиденциальность&raquo;,&nbsp;&mdash; подчеркивает Катерина
                  Милеева.
                </Paragraph>
                <Paragraph>
                  В&nbsp;рамках Lifеstyle Management клиентам банка доступна
                  специальная бонусная программа, включающая предложения
                  от&nbsp;мировых лидеров по&nbsp;наиболее востребованным
                  у&nbsp;наших клиентов услугам&nbsp;&mdash; авиакомпаниям,
                  отелям, fashion, ресторанам, wellness.
                </Paragraph>
                <Paragraph>
                  К&nbsp;тому&nbsp;же{' '}
                  <a
                    href="https://alfabank.ru/alfaprivate/?platformId=kommersant_special_project_alfaprivate_article3&utm_source=kommersant&utm_medium=special_project&utm_campaign=alfaprivate&utm_term=null&utm_content=article3"
                    target="_blank"
                  >
                    Альфа Private{' '}
                  </a>{' '}
                  проводят обучающие, спортивные и&nbsp;светские мероприятия,
                  на&nbsp;которых можно получить актуальные знания и&nbsp;найти
                  единомышленников и&nbsp;партнеров.
                </Paragraph>
                <Paragraph>
                  Естественно, как один из&nbsp;самых передовых российских
                  банков Альфа-Банк старается привлечь и&nbsp;молодое поколение
                  владельцев капитала&nbsp;&mdash; поэтому разрабатывает
                  программы образования, нацеленные на&nbsp;воспитание навыков
                  и&nbsp;знаний, необходимых для управления, сохранения
                  и&nbsp;приумножения семейного состояния.
                </Paragraph>
                <Fact>
                  &laquo;Одно из&nbsp;важнейших правил&nbsp;&mdash; никогда
                  не&nbsp;говорить клиенту, что ты&nbsp;ничем не&nbsp;можешь ему
                  помочь. Если в&nbsp;твоей бизнес-модели нет нужной клиенту
                  услуги, честно скажи об&nbsp;этом, но&nbsp;тут&nbsp;же
                  сориентируй, кто сможет решить его проблему, свяжи
                  с&nbsp;нужным человеком или организацией. А&nbsp;перед этим
                  проведи небольшой due diligence, позвони туда сам, узнай
                  условия, убедись в&nbsp;качестве предоставляемой
                  услуги&raquo;,&nbsp;&mdash; отмечает Катерина Милеева.
                </Fact>
                <Paragraph>
                  Спектр возможных услуг не&nbsp;ограничивается определенным
                  списком, он&nbsp;значительно разнообразнее. Зачастую клиентам
                  Private Banking требуются очень нестандартные услуги.
                  По&nbsp;словам Катерины Милеевой, один клиент обратился
                  с&nbsp;вопросом об&nbsp;организации проведения медицинского
                  консультирования и, при необходимости, сложной медицинской
                  операции по&nbsp;замене сустава в&nbsp;Швейцарии.
                  &laquo;Мы&nbsp;проконсультировались с&nbsp;рядом зарубежных
                  партнеров в&nbsp;области медицины по&nbsp;целесообразности
                  выбора именно Швейцарии для данного вида заболевания
                  и&nbsp;пришли к&nbsp;выводу, что в&nbsp;его случае данное
                  решение не&nbsp;является оптимальным. Поэтому предложили
                  пообщаться с&nbsp;нашим медицинским консультантом
                  (мы&nbsp;всегда направляем клиента к&nbsp;2&ndash;3 партнерам,
                  чтобы у&nbsp;клиента был выбор). По&nbsp;результатам первичных
                  консультаций клиент принял решение проводить обследование
                  и&nbsp;лечение в&nbsp;США,&nbsp;&mdash; отмечает собеседница.
                  &mdash;&nbsp;
                  <Accentuation>
                    Наши партнеры подобрали клинику и&nbsp;лучшего хирурга
                    по&nbsp;данному направлению. А&nbsp;также предоставили
                    услуги по&nbsp;обеспечению полного сопровождения процесса
                    начиная от&nbsp;организации поездки, культурной программы
                    для супруги клиента, которая его сопровождала,
                    и&nbsp;заканчивая поиском няни для ребенка на&nbsp;время
                    поездки&raquo;.{' '}
                  </Accentuation>
                </Paragraph>
              </ArticleSpreader>
            </div>
          ),
        },
        {
          title: 'Учение свет',
          body: (
            <div>
              <ArticleSpreader>
                <Paragraph>
                  Состояние&nbsp;&mdash; это более широкое понятие, чем
                  финансовые и&nbsp;инвестиционные активы: оно включает также
                  и&nbsp;недвижимость (обычно глобально диверсифицированную),
                  яхты, коллекции искусства и&nbsp;многое другое, отмечает
                  Катерина Милеева. Поэтому на&nbsp;базе Private Banking
                  в&nbsp;компании развивают компетенции в&nbsp;предоставлении
                  широкого спектра нефинансовых услуг нашим клиентам.
                  &laquo;Происходит это в&nbsp;основном за&nbsp;счет привлечения
                  лучших внешних провайдеров, а&nbsp;нашу роль мы&nbsp;видим
                  в&nbsp;выборе лучших партнеров, мониторинге высочайшего
                  качества оказания услуги нашему клиенту и&nbsp;соблюдении
                  интересов наших клиентов в&nbsp;ходе
                  сделки&raquo;,&nbsp;&mdash; подчеркивает Катерина Милеева.
                </Paragraph>
                <Paragraph>
                  Однако для того чтобы удовлетворять высокие требования
                  клиентов и&nbsp;всегда предлагать только актуальные
                  и&nbsp;лучшие продукты, одного контроля партнеров
                  недостаточно. Поэтому сотрудники Альфа Private проходят
                  обязательную сертификацию. В&nbsp;прошлом году все действующие
                  сотрудники банка получили сертификат ФСФР, подтверждающий
                  их&nbsp;знания рынка ценных бумаг, производных финансовых
                  инструментов, бухгалтерского учета, международного
                  и&nbsp;российского налогообложения и&nbsp;многого другого.
                </Paragraph>
                <Paragraph>
                  &laquo;На&nbsp;регулярной основе проводятся программы обучения
                  по&nbsp;самым важным трендам налогового, юридического
                  законодательства, комплаенс, управления комплаенс-рисками,
                  портфельными рисками&raquo;,&nbsp;&mdash; отмечает госпожа
                  Милеева.
                </Paragraph>
                <Paragraph>
                  К&nbsp;тому&nbsp;же Альфа Private проводят{' '}
                  <Accentuation>
                    обучающие, спортивные и&nbsp;светские мероприятия,{' '}
                  </Accentuation>
                  на&nbsp;которых можно получить актуальные знания и&nbsp;найти
                  единомышленников и&nbsp;партнеров.
                </Paragraph>
                <Paragraph>
                  В&nbsp;прошлом году совместно с&nbsp;бизнес-школой
                  &laquo;Сколково&raquo; была запущена уникальная программа
                  повышения квалификации персональных банкиров&nbsp;&mdash;
                  &laquo;Будущий частный банкир сегодня&raquo;.
                  В&nbsp;ее&nbsp;основе лежат результаты исследований Центра
                  управления благосостоянием и&nbsp;филантропии
                  &laquo;Сколково&raquo; и&nbsp;опросов российских бизнесменов
                  и&nbsp;их&nbsp;окружения, а&nbsp;также исследования способов
                  мышления и&nbsp;восприятия владельцев капитала. Слушателями
                  первого потока стали 30 финансовых советников Альфа Private.
                </Paragraph>
                <EndSpreader />
                <MoreArticles
                  articles={[
                    {
                      title: 'Private Banking - от финансов до стиля жизни',
                      url: '/overview',
                      background: 'images/media/anons1.jpg',
                    },
                    {
                      title: 'Цифровые капиталы',
                      url: '/digital',
                      background: 'images/media/anons211.jpg',
                    },
                    {
                      title: 'Наш внутренний девиз — у нас всегда есть решение»',
                      url: '/interview',
                      background: 'images/media/anons4.jpg',
                    },
                  ]}
                />
              </ArticleSpreader>
            </div>
          ),
        },
      ]}
    </Article>
  </div>
);

export default InvestPage;
